module.exports = __webpack_public_path__ + "img/binner.9d980df1.png";